/*
* This function builds the subscription quiz
*/
import * as cart from '@shopify/theme-cart';

export const initSubscriptionQuizResult = (): void => {

  const quizAnswers = JSON.parse(localStorage.getItem('subscripionQuizAnswers'))

  // console.log('answers', quizAnswers)

  if (!quizAnswers) { return }

  const giftDownload = document.querySelector('[data-gift-download]') as HTMLDivElement;
  if (giftDownload && quizAnswers.q1.option === '2') {
    giftDownload.classList.remove('hide')
  }


  const quizSection = document.querySelector('[data-quiz-result]') as HTMLDivElement;
  const quizBackSection = document.querySelector('[data-quiz-back]') as HTMLDivElement;

  if (!quizSection) { return }



  // steps
  const howOftenEl = document.querySelector('[data-how-often]') as HTMLDivElement;
  const howLongEl = document.querySelector('[data-how-long]') as HTMLDivElement;
  const howEl = document.querySelector('[data-how]') as HTMLDivElement;
  const packageNameEl = document.querySelector('[data-package-name]') as HTMLDivElement;
  const addToCart = document.querySelector('[data-subscription-redirect]') as HTMLDivElement;
  const durationSelect = document.querySelector('[data-option-duration]') as HTMLSelectElement;
  const durationHiddenInput = document.querySelector('[name="properties[charge_interval_frequency]"]') as HTMLInputElement;

  // mountain bike option
  const maillistMountainBike = document.querySelector('#mc-embedded-subscribe-form input[value="4194304"]') as HTMLInputElement
  const maillistRoadBike = document.querySelector('#mc-embedded-subscribe-form input[value="8388608"]') as HTMLInputElement
  const maillistEbike = document.querySelector('#mc-embedded-subscribe-form input[value="1073741824"]') as HTMLInputElement

  if (quizAnswers.q4.option === '1' && maillistMountainBike !== null) {
    maillistRoadBike.checked = true
  }

  if (quizAnswers.q4.option === '2' && maillistMountainBike !== null) {
    maillistMountainBike.checked = true
  }

  if (quizAnswers.q4.option === '3' && maillistMountainBike !== null) {
    maillistRoadBike.checked = true
    maillistMountainBike.checked = true
  }

  if (quizAnswers.q5.option === '2' && maillistEbike !== null) {
    maillistEbike.checked = true
  }

  if (howOftenEl) {
    howOftenEl.innerText = quizAnswers.q2.text
  }

  if (howLongEl) {
    howLongEl.innerText = quizAnswers.q3.text
  }

  if (howEl) {
    howEl.innerText = quizAnswers.q5.text
  }

  if (packageNameEl) {
    packageNameEl.innerText = quizAnswers.product.name
  }

  if (addToCart) {
    addToCart.addEventListener('click', (e) => {
      e.preventDefault()

      const el = <HTMLInputElement>e.target;
      el.classList.add('loading');

      let productId = parseInt(el.dataset.atcProductId);
      // handle ReCharge product ids
      const rcSelect = <HTMLSelectElement>document.querySelector('#rc_duplicate_selector');

      if (rcSelect) {
        productId = parseInt(rcSelect.value)
      }
      const quantity = 1
      const properties = {}
      //see if we have subscription properties
      const propertiesToGet = [
        'subscription_id',
        'shipping_interval_unit_type',
        'shipping_interval_frequency',
        'charge_interval_frequency',
        'charge_interval_unit_type',
        'number_charges_until_expiration'
      ];
      propertiesToGet.forEach((property) => {
        const key = `properties[${property}]`
        const el = <HTMLInputElement>document.querySelector(`[name="${key}"]`) // make this work :smile:
        if (!el) {
          return;
        }
        properties[`${property}`] = el.value;
      });

      cart.addItem(productId, { quantity: quantity, properties: properties })
        .then(() => {
          if (quizAnswers.q51.option) {
            return cart.getAttributes().then((attributes) => {
              attributes['order_delay_days'] = quizAnswers.q51.option;

              return cart.updateAttributes(attributes);
            });
          } else {
            return cart.getAttributes().then((attributes) => {
              if (attributes['order_delay_days']) {
                attributes['order_delay_days'] = '';

                return cart.updateAttributes(attributes);
              }

              return true;
            });
          }
        })
        .then(() => {
          window.location.href = '/pages/subscription-added-to-cart'
        });
    });
  }

  if (durationSelect) {
    durationSelect.addEventListener('change', () => {
      durationHiddenInput.value = durationSelect.selectedOptions[0].dataset.subValue ? durationSelect.selectedOptions[0].dataset.subValue : durationSelect.value;
    })
  }

  quizSection.classList.remove('hide')
  quizBackSection.classList.remove('hide')
}